import { Injectable } from '@angular/core'
import { reactor } from '../reactor'
import { userOperations } from '../stores/user-store'

@Injectable({providedIn: 'root'})
export class UiActions {
  setUiState(key: String, value: any) {
    reactor.dispatch(userOperations.setUiState, {key, value})
  }
}
